import { Component, Inject, OnInit } from '@angular/core';
import { InventoryDataService } from '@services';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-create-offer-sample',
  imports: [RmsModule],
  templateUrl: './create-offer-sample.component.html',
  styleUrl: './create-offer-sample.component.scss'
})
export class CreateOfferSampleComponent implements OnInit{
  Suppliers: any[] = [];
  Products: any[] = [];
  OfferSample: any;
  constructor(private pulldownRef: RmsPulldownRef, @Inject(RMS_PULLDOWN_DATA) public data: any, private inventoryData: InventoryDataService) {
    this.OfferSample = this.data || {};
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData() {
    const result = await this.inventoryData.getData({ keys: ['Suppliers', 'Products'] });
    this.Suppliers = result['Suppliers'];
    this.Products = result['Products'];
  }

  save() {
    this.pulldownRef.close({ ...this.OfferSample, cancelled: false });
  }
  createPurchaseOrder() {
    this.pulldownRef.close({ ...this.OfferSample, createPurchaseOrder: true, cancelled: false });
  }
  cancel() {
    this.pulldownRef.close({ cancelled: true });
  }
}
